import React, { useMemo } from 'react';
import { useLocation, Link } from 'react-router-dom';
import { useData } from '../../context/DataContext';

const useQuery = () => new URLSearchParams(useLocation().search);

const matchText = (text, query) => {
  if (!text) return false;
  return text.toLowerCase().includes(query.toLowerCase());
};

export default function StudentSearch() {
  const query = useQuery();
  const q = query.get('q') || '';
  const { assignments = [], announcements = [], resources = [], messages = [] } = useData() || {};

  const results = useMemo(() => {
    if (!q) return { assignments: [], announcements: [], resources: [], messages: [] };
    return {
      assignments: assignments.filter(item => matchText(item.title || item.name, q) || matchText(item.description || item.summary, q)),
      announcements: announcements.filter(item => matchText(item.title, q) || matchText(item.content, q)),
      resources: resources.filter(item => matchText(item.title || item.name, q) || matchText(item.description, q)),
      messages: messages.filter(item => matchText(item.subject || item.title, q) || matchText(item.body || item.message, q))
    };
  }, [q, assignments, announcements, resources, messages]);

  const total = results.assignments.length + results.announcements.length + results.resources.length + results.messages.length;

  return (
    <div>
      <div className="page-header">
        <h1 className="page-title">Search</h1>
        <p className="page-subtitle">Showing results for “{q}”</p>
      </div>

      <div className="grid" style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: '16px' }}>
        <div className="card">
          <div className="card-header"><h3 style={{ fontSize: '1rem' }}>Assignments</h3></div>
          <div className="card-body">
            {results.assignments.length === 0 ? (
              <div style={{ color: 'var(--gray-500)' }}>No matches</div>
            ) : (
              results.assignments.map(item => (
                <div key={item.id} style={{ marginBottom: '10px' }}>
                  <div style={{ fontWeight: 600 }}>{item.title || item.name}</div>
                  <div style={{ fontSize: '0.85rem', color: 'var(--gray-500)' }}>{item.description || item.summary || ''}</div>
                </div>
              ))
            )}
          </div>
        </div>

        <div className="card">
          <div className="card-header"><h3 style={{ fontSize: '1rem' }}>Announcements</h3></div>
          <div className="card-body">
            {results.announcements.length === 0 ? (
              <div style={{ color: 'var(--gray-500)' }}>No matches</div>
            ) : (
              results.announcements.map(item => (
                <div key={item.id} style={{ marginBottom: '10px' }}>
                  <div style={{ fontWeight: 600 }}>{item.title}</div>
                  <div style={{ fontSize: '0.85rem', color: 'var(--gray-500)' }}>{item.content || ''}</div>
                </div>
              ))
            )}
          </div>
        </div>

        <div className="card">
          <div className="card-header"><h3 style={{ fontSize: '1rem' }}>Resources</h3></div>
          <div className="card-body">
            {results.resources.length === 0 ? (
              <div style={{ color: 'var(--gray-500)' }}>No matches</div>
            ) : (
              results.resources.map(item => (
                <div key={item.id} style={{ marginBottom: '10px' }}>
                  <div style={{ fontWeight: 600 }}>{item.title || item.name}</div>
                  <div style={{ fontSize: '0.85rem', color: 'var(--gray-500)' }}>{item.description || ''}</div>
                </div>
              ))
            )}
          </div>
        </div>

        <div className="card">
          <div className="card-header"><h3 style={{ fontSize: '1rem' }}>Messages</h3></div>
          <div className="card-body">
            {results.messages.length === 0 ? (
              <div style={{ color: 'var(--gray-500)' }}>No matches</div>
            ) : (
              results.messages.map(item => (
                <div key={item.id} style={{ marginBottom: '10px' }}>
                  <div style={{ fontWeight: 600 }}>{item.subject || item.title}</div>
                  <div style={{ fontSize: '0.85rem', color: 'var(--gray-500)' }}>{item.body || item.message || ''}</div>
                </div>
              ))
            )}
          </div>
        </div>
      </div>

      <div style={{ marginTop: '16px', color: 'var(--gray-500)' }}>
        {total === 0 ? 'No results found.' : `${total} result(s) found.`}
        {' '}<Link to="/student/dashboard">Back to Dashboard</Link>
      </div>
    </div>
  );
}
